import { Snackbar } from 'buefy/dist/components/snackbar';

const default_options = {
  duration: 7000,
  position: 'is-bottom-left'
}

export default {
  default(text, option = {}) {
    if (!helpers.isEmpty(text)) {
      Snackbar.open(Object.assign({}, default_options, Object.assign({}, {
        message: text,
      }, option)));
    }
  },

  notice(text, option) {
    this.default(text, option);
  },

  success(text, option = {}) {
    if (!helpers.isEmpty(text)) {
      Snackbar.open(Object.assign({}, default_options, Object.assign({}, {
        message: text,
        type: 'is-success'
      }, option)));
    }
  },

  info(text, option = {}) {
    if (!helpers.isEmpty(text)) {
      Snackbar.open(Object.assign({}, default_options, Object.assign({}, {
        message: text,
        type: 'is-info'
      }, option)));
    }
  },

  danger(text, option) {
    if (!helpers.isEmpty(text)) {
      Snackbar.open(Object.assign({}, default_options, Object.assign({}, {
        message: text,
        type: 'is-danger'
      }, option)));
    }
  },

  error(text, option) {
    this.danger(text, option);
  }
};
